import './App.css';
import './responsive/laptop.css'
import './responsive/tablet.css'
import './responsive/mobile.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Banner from './components/Commons/Banner/Banner';
import Home from './components/Home/Home';
import About from './components/About/About';
import Footer from './components/Footer/Footer';
import Courses from './components/Courses/Courses';
import Contact from './components/Contact/Contact';
import Placements from './components/Placements/Placements';
import Bar from './components/BarManagementSection/Bar';
import Blogs from './components/Commons/Blogs/Blogs';
import OneBlog from './components/Commons/OneBlog/OneBlog';
import SpecialCourse from './components/Special Course/SpecialCourses';

function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <>
          <Navbar />
          <Banner />
          <Home />
          <Footer />
        </>
      )
    },
    {
      path: '/about',
      element
        : (
          <>
            <Navbar />
            <About />
            <Footer />
          </>
        )
    },
    {
      path: '/courses',
      element
        : (
          <>
            <Navbar />
            <Courses />
            <Footer />
          </>
        )
    },
    {
      path: '/placements',
      element
        : (
          <>
            <Navbar />
            <Placements/>
            <Footer />
          </>
        )
    },
    {
      path: '/blogs',
      element
        : (
          <>
            <Navbar />
            <Blogs/>
            <Footer />
          </>
        )
    },
    {
      path: '/contact',
      element
        : (
          <>
            <Navbar />
            <Contact/>
            <Footer />
          </>
        )
    },
    {
      path: '/hotel-management',
      element
        : (
          <>
            <Navbar />
            <Bar/>
            <Footer />
          </>
        )
    },
    {
      path: '/special-courses',
      element
        : (
          <>
            <Navbar />
            <SpecialCourse/>
            <Footer />
          </>
        )
    },
    {
      path:'/blog/:id', // Corrected the route path
      element
      : <>
      <Navbar/>
      <OneBlog/>
      <Footer/>
      </>
    }
  ]);
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
